import { useState } from 'react';
import AnimatedHistogramChartCard from './AnimatedHistogramChartCard';
import { Button } from 'react-bootstrap';
import { ArrowDownUp } from 'icone';

export default function HistogramCards({ standard, details, lastStatementRender }) {
	const [activeHistogram, setActiveHistogram] = useState('standard');
	const arrowStyles = {
		width: '16px',
		height: '9px',
		translate: '0 -3px',
	};
	return (
		<>
			{activeHistogram === 'standard' ? (
				<>
					<AnimatedHistogramChartCard
						title={'Rendicontazione (€)'}
						data={standard.data}
						order={standard.order}
						cardData={standard.cardData}
						totalName="reportedAmount"
					/>
					{lastStatementRender(activeHistogram)}
					<Button
						variant="link"
						onClick={() => setActiveHistogram('details')}
						className="align-items-center text-decoration-none"
						style={{ display: 'block', marginLeft: 'auto', marginBlock: '0.3rem' }}
					>
						DETTAGLIO CONTRIBUTO RICHIESTO{' '}
						<ArrowDownUp
							style={{
								...arrowStyles,
								rotate: '-90deg',
							}}
						/>
					</Button>
				</>
			) : null}

			{activeHistogram === 'details' ? (
				<>
					<AnimatedHistogramChartCard
						title={'Rendicontazione (€)'}
						data={details.data}
						order={details.order}
						cardData={details.cardData}
						totalName="reportedAmount"
					/>
					{lastStatementRender(activeHistogram)}
					<Button
						variant="link"
						onClick={() => setActiveHistogram('standard')}
						className="align-items-center text-decoration-none"
						style={{ paddingBlock: '0.3rem' }}
					>
						<ArrowDownUp style={{ ...arrowStyles, rotate: '90deg' }} /> INDIETRO
					</Button>
				</>
			) : null}
		</>
	);
}
